
<div style="border: none; position: absolute; top: 10%; overflow: hidden; padding: 20px; width: 94%;">
 <localization-grid *ngIf="!(editFormId$ | async)"></localization-grid>
  <localization-grid-form *ngIf="editFormId$ | async" [oid]=" editFormId$ | async"></localization-grid-form>
</div>

